import React from 'react';
import { Box, Typography, Alert } from '@mui/material';

const SimpleSettingsPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>
      <Alert severity="info">
        Settings page is being updated to use service account APIs. 
        Check back soon!
      </Alert>
    </Box>
  );
};

export default SimpleSettingsPage;



